import React from "react";
import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import { ToothStateEnum } from "requests";
import { TeethData } from "../../duck";
import { getToothData } from "./duck";

interface DentalArcadeProps {
  title: string;
  teethNumbers: { [key in "1" | "2" | "3" | "4"]: number[] };
  arcadeNumber: 1 | 2 | 3 | 4;
  allTeethData: TeethData;
}

const DentalArcade: React.FC<DentalArcadeProps> = ({
  teethNumbers,
  arcadeNumber,
  allTeethData,
  title
}) => {
  const teeth = teethNumbers[arcadeNumber].filter(toothNumber =>
    Object.keys(allTeethData).includes(String(toothNumber))
  );

  return (
    <>
      <Text color="gray.700" fontWeight="bold" fontSize="lg">
        {title}
      </Text>
      <Box mt={2}>
        {teeth.length ? (
          teeth.map(toothNumber => {
            const { toothState, ...tooth } = allTeethData[toothNumber];
            const isToothUnhealthy = toothState === ToothStateEnum.Abnormal;
            const { periodontalPockets, data } = getToothData(tooth);

            return (
              <HStack
                color={isToothUnhealthy ? "#C41212" : "gray.700"}
                align="top"
                key={toothNumber}
              >
                <Text fontWeight="bold">{toothNumber}:</Text>
                <Flex direction="column">
                  {periodontalPockets && <Text>{periodontalPockets}</Text>}
                  {data && <Text>{data}</Text>}
                </Flex>
              </HStack>
            );
          })
        ) : (
          <Text>No Records</Text>
        )}
      </Box>
    </>
  );
};

export default DentalArcade;
